import type {
  ActiveBillingCycleItem,
  BillingCycleTabCounts,
  EpisodicClaimStatus,
  GetBillingCyclesResponse,
} from '../../services/api/types.gen';

export type BillingCycleNoteContext = {
  billingCycleId: string;
  billingCycleStatus: EpisodicClaimStatus;
  isDraftReady?: boolean | null;
  noteCountsByTab?: BillingCycleTabCounts;
};

export function draftBillingCycleNoteContext(
  entry: GetBillingCyclesResponse,
  isDraftReady: boolean
): BillingCycleNoteContext {
  return {
    billingCycleId: entry.billing_cycle_id,
    billingCycleStatus: entry.status,
    isDraftReady,
    noteCountsByTab: entry.note_counts,
  };
}

export function activeBillingCycleNoteContext(
  entry: ActiveBillingCycleItem
): BillingCycleNoteContext {
  return {
    billingCycleId: entry.billing_cycle_id,
    billingCycleStatus: entry.billing_cycle_status,
    isDraftReady: null,
    noteCountsByTab: entry.note_counts,
  };
}
